import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { postUserLoginThunk } from "tm-shared/api";

import {
    ACCESS_INTERVAL,
    ACCESS_TOKEN,
    REFRESH_INTERVAL,
    REFRESH_TOKEN,
    TOKEN_EXPIRY_KEY,
} from "@/constants/config/auth";

import { AuthState } from "./auth.slice.types";

export const isTokenExpired = () => {
    const tokenTimestamp = localStorage.getItem(TOKEN_EXPIRY_KEY);
    if (!tokenTimestamp) return true;

    const tokenAge = Date.now() - parseInt(tokenTimestamp, 10);
    if (tokenAge > Number(localStorage.getItem(TOKEN_EXPIRY_KEY))) {
        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem(TOKEN_EXPIRY_KEY);
        localStorage.removeItem(REFRESH_TOKEN);
        localStorage.removeItem(ACCESS_INTERVAL);
        localStorage.removeItem(REFRESH_INTERVAL);
    }
    return {
        accessTokenExpired:
            tokenAge > Number(localStorage.getItem(ACCESS_INTERVAL)),
        refreshTokenExpired:
            tokenAge > Number(localStorage.getItem(REFRESH_INTERVAL)),
    };
};

function getInitialState(): AuthState {
    return {
        accessInterval: 0,
        refreshInterval: 0,
        refreshToken: "",
        isAuthenticated: Boolean(localStorage.getItem(ACCESS_TOKEN)),
        accessToken: isTokenExpired() ? "" : localStorage.getItem(ACCESS_TOKEN),
        isOnline: false,
        networkStatus: "",
    };
}

const initialState: AuthState = getInitialState();

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        updateStatus(state, action: PayloadAction<boolean>) {
            state.isOnline = action.payload;
        },
        setNetworkStatus(state, action) {
            state.networkStatus = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(postUserLoginThunk.fulfilled, (state, action) => {
            state.accessToken = action.payload.result.accessToken;
            state.isAuthenticated = !!action.payload.result.accessToken;
            localStorage.setItem(
                ACCESS_TOKEN,
                action.payload.result.accessToken,
            );
            localStorage.setItem(
                REFRESH_TOKEN,
                action.payload.result.refreshToken,
            );
            localStorage.setItem(
                ACCESS_INTERVAL,
                String(action.payload.result.accessInterval),
            );
            localStorage.setItem(
                REFRESH_INTERVAL,
                String(action.payload.result.refreshInterval),
            );
            localStorage.setItem(TOKEN_EXPIRY_KEY, Date.now().toString());
        });
    },
});

export const { updateStatus, setNetworkStatus } = authSlice.actions;

export default authSlice.reducer;
